import type React from 'react';

import { Image, Link, Text } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';

import type { NewsAndGuidesListItem } from '#src/app/pages/newsAndGuides/list/pageContext';
import { useItemCard } from '#src/app/pages/newsAndGuides/list/shared/hooks';
import { Html } from '#src/app/shared/components/html';

type Props = {
	item: NewsAndGuidesListItem;
};

export const ExpandedCard: React.FC<Props & { ref?: React.RefObject<HTMLAnchorElement | null> }> = ({ item, ref }) => {
	const {
		data: { categoryName, targetUrl, photoUrl },
	} = useItemCard(item);
	const getStaticAssetUrl = useGetStaticAssetUrl();

	return (
		<Link
			href={targetUrl}
			ref={ref}
			data-qa="expanded-card-link"
			className="text-typography-strong hover:text-typography-strong no-underline **:no-underline"
		>
			<div className="relative block h-auto w-full md:flex md:h-[264px] md:items-center md:justify-end">
				<div className="absolute top-0 left-0 z-0 h-[220px] w-full md:h-full md:w-[60%] lg:w-[50%]">
					<Image
						src={photoUrl}
						fallback={
							<Image
								src={getStaticAssetUrl('/images/default-petition.gif')}
								alt=""
								className="rounded-small h-full w-full object-cover"
								loading="lazy"
								role="presentation"
							/>
						}
						alt=""
						className="rounded-small h-full w-full object-cover"
						loading="lazy"
						role="presentation"
					/>
				</div>
				<div className="rounded-small bg-fill-inverse-strong relative z-10 mt-56 w-full py-6 pr-2 pl-2 md:mt-0 md:w-[58%] md:pr-10 md:pl-6">
					<Text as="span" fontWeight="bold" size="x-small" className="text-typography-weak uppercase">
						{categoryName}
					</Text>
					<Text as="h2" variant="heading" size="small" className="text-typography-strong mt-2 mb-6">
						{item.title}
					</Text>
					<Text as="div" size="small" className="text-typography-weak">
						<Html as="div" html={item.excerpt} breakWord className="md:line-clamp-3" />
					</Text>
				</div>
			</div>
		</Link>
	);
};
